import React, { useContext } from 'react';
import { useWizard } from 'react-use-wizard';
import { Button } from '../../util/buttons';
import CardStep from '../../wizard/CardStep';
export default function ChooseUploadOrDownloadStep(_ref) {
  let {
    stepConfig,
    NavigationContext
  } = _ref;
  const {
    goToStep
  } = useWizard();
  const navigationDirection = useContext(NavigationContext);

  // const goToUploadDataStep = () => {
  //   navigationDirection.current = 1; // Going forward
  //   goToStep(stepConfig['UploadDataStep'].index)
  // };

  const goToDownloadDataStep = () => {
    navigationDirection.current = 1; // Going forward
    goToStep(stepConfig['DownloadDataStep'].index);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CardStep, {
    title: "What would you like to do?",
    NavigationContext: NavigationContext
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column h-100"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-auto mb-auto d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: goToDownloadDataStep
  }, "Download Data")))));
}